<div class="card h-150px h-sm-200 mb-4 cursor-pointer" (click)="onClientSelected()">
    <div class="card-body d-flex flex-column">
        <h3 class="card-title align-items-start flex-column">
            <span class="card-label fw-bold text-dark">{{client.name}}</span>
        </h3>
    </div>
</div>